import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
const toDim = (v) => typeof v === 'number' ? `${v}px` : v;
/** Lade-Platzhalter (MUI-`Skeleton`-Ersatz) auf `.sec-skeleton`-Basis. */
export const Skeleton = forwardRef(function Skeleton({ variant = 'text', width, height, style, className, ...rest }, ref) {
    const dims = {
        width: toDim(width),
        height: toDim(height) ?? (variant === 'text' ? '1em' : undefined),
        borderRadius: variant === 'circle' ? '50%' : undefined,
        ...style,
    };
    return (_jsx("span", { ref: ref, "aria-hidden": "true", className: cn('sec-skeleton', className), style: dims, ...rest }));
});
